// ##########################################################################################
// Gallery Data Manager
// ==========================================================================================
// The Data manager object, defined by the return value of the function below, is a
// submodule of the JDA gallery module. This submodule is responsible for storing entry data
// in memory, and fetching data from the server (when prompted to do so by the main gallery
// module). As its responsible for fetching data from the server, this submodule is also
// responsible for managing a data transfer object which gets sent to the server, describing
// to it the data that it wants back.
// ##########################################################################################

var galleryModule = app.mediator.getModule(MODULE_NAME__GALLERY);
galleryModule.injectSubModule('dataManager', function() {

	// =======================================================================
	// Module data
	// =======================================================================

    var helpers = app.helpers.funcs;

	var filtersDto = {};
    var currentDtoHasBeenSentAtLeastOnce = false;
    var lastFetchedEntriesData;
	var entriesData = [];
	var serverApiUrl = helpers.url('/umbraco/api/EntryApi/Entries');
    var ajaxRequests = [];
    var hasAjaxRequestsPending = false;
    var numberOfItemsPerLoad = 30;
    var searchText = '';

	// =======================================================================
	// Immediately invoked init code
	// =======================================================================

    $(document).ajaxStart(function() { hasAjaxRequestsPending = true; });
    $(document).ajaxStop(function() { hasAjaxRequestsPending = false; });

	// =======================================================================
	// Filters
	// =======================================================================

    function updateFiltersDtoSearchText(newText) {
        if (searchText != newText) currentDtoHasBeenSentAtLeastOnce = false;
        searchText = newText;
    }

	function setFiltersDto(filtersDtoArg) {
		filtersDto = filtersDtoArg;
        currentDtoHasBeenSentAtLeastOnce = false;
	}

	function modifyFiltersDto(substitutes, considerDtoNew) {
        considerDtoNew = typeof considerDtoNew !== 'undefined' ? !!considerDtoNew : true;
		Object.keys(substitutes).forEach(function(subKey) {
			filtersDto[subKey] = substitutes[subKey];
		});
        if (considerDtoNew) currentDtoHasBeenSentAtLeastOnce = false;
	}

    // When getting the filters DTO, set the skip and take parameters to the number of items currently loaded,
    // and the number of items to retrieve per server visit, respectively. It also retrieves the search text,
    // which is treated dynamically.
    // Whenever getting the filtersDto, it should be retrieved via this method for these reasons.
    function getFiltersDto() {
        return $.extend({}, filtersDto, {
            skip: entriesData.length,
            take: filtersDto.take ? filtersDto.take : numberOfItemsPerLoad,
            text: searchText
        });
    }

    function filtersDtoHasBeenPopulated() {
        return !JSON.stringify(filtersDto) === '{}';
    }

    // This method converts the dto thats used to describe gallery filter state to the client side code
    // into a format thats congruent with the server API.
    function getFiltersDtoForServer() {
        var clientSideDto = $.extend({}, getFiltersDto());
        var serverSideDto = {
            prizes: clientSideDto.prizes,
            winnersOnly: clientSideDto.winnersOnly,
            defaultSortOrder: clientSideDto.defaultSortOrder,
            text: clientSideDto.text,
            awards: clientSideDto.awards,
            territories: clientSideDto.territories,
            categories: clientSideDto.categories,
            entriesToSkip: clientSideDto.skip,
            numberOfEntries: clientSideDto.take,
            pageCultureCode: clientSideDto.pageCultureCode,
            requestCultureCode: clientSideDto.requestCultureCode
        };
        if (clientSideDto.prize instanceof Array) {
            clientSideDto.prize.forEach(function (joinedPrizeList) {
                joinedPrizeList.split(',').forEach(function (prize) {
                    serverSideDto.prizes.push(prize);
                });
            });
        }
        return serverSideDto;
    }

	// =======================================================================
	// Data transport
	// =======================================================================

    function getNumberPerLoad() {
        return numberOfItemsPerLoad;
    }

    function setEntriesData(entriesDataArg) {
        entriesData = entriesDataArg;
    }

    function getEntriesData() {
        return entriesData;
    }

    function clearEntriesData() {
        entriesData = [];
    }

	function fetchEntriesThen(cb) {

        var data = getFiltersDtoForServer();

        var xhr = $.ajax({
            type: "POST",
            url: serverApiUrl,
            data: data,
            dataType: "json",
            success: function (response) {

                var entries = response.result;

                // Notify the mediator that the gallery module has just fetched more entries.
                app.mediator.notify(EVENT_NAME__GALLERY__ITEM_LIST_UPDATED);

                // Run the callback function that was supplied to this function, if applicable.
                if (typeof cb === 'function') cb(entries);

                // Store what the server returned in its last server call within this module.
                // This information is needed to work out if the gallery module should consider
                // itself to have grabbed all the records there are to grab from the server or not.
                // Important: lastFetchedEntriesData is a copy, not a reference.
                lastFetchedEntriesData = [].concat(entries);
                currentDtoHasBeenSentAtLeastOnce = true;
            }
        });
        ajaxRequests.push(xhr);
	}

	function fetchEntriesAndSpliceThen(cb) {
        fetchEntriesThen(function(entriesDataFromServer) {
            entriesData = entriesData.concat(entriesDataFromServer);
            if (typeof cb === 'function') cb(entriesDataFromServer);
        });
	}

	function abortFetch() {
        ajaxRequests.forEach(function(ajaxRequest) {
            ajaxRequest.abort();
        });
        galleryModule.onAjaxAbort();
	}

    function hasFetchesPending() {
        return hasAjaxRequestsPending;
    }

    function hasFetchedAllEntries() {
        return currentDtoHasBeenSentAtLeastOnce === true && lastFetchedEntriesData.length < numberOfItemsPerLoad;
    }

	// =======================================================================
	// Misc
	// =======================================================================

    // Checks to see if itemData contains all the necessary pieces of
    // data, to be considered a valid template HTML mutator.
    function itemDataAdheresToInterface(itemData) {
        if (typeof itemData.id === 'undefined') return false;
        if (typeof itemData.name === 'undefined') return false;
        if (typeof itemData.description === 'undefined') return false;
        if (typeof itemData.badge === 'undefined') return false;
        if (typeof itemData.projectUrl === 'undefined') return false;
        if (typeof itemData.imageUrl === 'undefined') return false;
        return true;
    }

	// =======================================================================
	// Public API
	// =======================================================================

	return {
        getNumberPerLoad: getNumberPerLoad,
        setEntriesData: setEntriesData,
        getEntriesData: getEntriesData,
        getFiltersDto: getFiltersDto,
        updateFiltersDtoSearchText: updateFiltersDtoSearchText,
        clearEntriesData: clearEntriesData,
        setFiltersDto: setFiltersDto,
        modifyFiltersDto: modifyFiltersDto,
        filtersDtoHasBeenPopulated: filtersDtoHasBeenPopulated,
        abortFetch: abortFetch,
        hasFetchesPending: hasFetchesPending,
        fetchEntriesThen: fetchEntriesThen,
        fetchEntriesAndSpliceThen: fetchEntriesAndSpliceThen,
        hasFetchedAllEntries: hasFetchedAllEntries,
		itemDataAdheresToInterface: itemDataAdheresToInterface
	};
});